import { PoposedToTheSubCommittee3ApproveContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee3ApproveContainer";
export function PoposedToTheSubCommittee3ApprovePage() {

    return (
        <PoposedToTheSubCommittee3ApproveContainer />
    )
}




